/*
 * Organize Color Objects by spectrum
 * Organize codes by light -> dark
 */
const colors = {
  white: '#ffffff',
  red: {
    400: '#d31315',
  },
  orange: {
    500: '#e86929',
  },
  yellow: {
    400: '#f7b500',
  },
  green: {
    400: '#4ab653',
  },
  teal: {
    600: '#008e86',
  },
  blue: {
    400: '#5893d4',
    700: '#345fed',
    800: '#2e3e55',
  },
  grey: {
    50: '#f5f8fa',
    100: '#ebf0f3',
    200: '#e5eaee',
    300: '#c2cbcc',
    500: '#859198',
    600: '#616A70',
    900: '#171d26',
  },
};

export default colors;
